import { Crop, Net } from '@crops';
import { EnvType } from '@metadata';
import Axios, { AxiosResponse } from 'axios';
import env from '../config/env';

const ENV: EnvType = env() as EnvType;

const API_URL = `${ENV.BACKEND_API}`;
const AUTH_URL = `${ENV.AUTH_PATH}`;

const svcApi = Axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json;charset=UTF-8',
    'Content-type': 'application/json;charset=UTF-8',
  },
});

const authApi = Axios.create({
  baseURL: AUTH_URL,
  headers: {
    Accept: 'application/json;charset=UTF-8',
    'Content-type': 'application/json;charset=UTF-8',
  },
});

const fileApi = Axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json;charset=UTF-8',
    'Content-Type': 'multipart/form-data',
  },
});

function extractOnlyData(result: AxiosResponse<any>) {
  if (result.data.status !== 'OK') throw new Error(`호출 실패 ${result.data.statusText}`);
  return result.data;
}

function extract(result: AxiosResponse<any>) {
  if (result.data.status === 'NULL_POINT') {
    throw {
      ...result.data,
    };
  }
  if (result.data.status !== 'OK') throw new Error(`호출 실패 ${result.data.statusText}`);
  if (result.data) {
    return result.data.data;
  }
}
function processValues(obj: any) {
  const updatedObj = { ...obj };

  for (const key in updatedObj) {
    if (key === 'pageNo') continue;
    if (key === 'sameCd') continue;
    if (key === 'tillageCd') continue;
    if (updatedObj[key] === '0' || !updatedObj[key]) {
      delete updatedObj[key];
    }
  }

  return updatedObj;
}

function logger(response: AxiosResponse) {
  // url, request param, response data
  console.log(`api - [${response.config.url}]`, response.config.params, response.data.data);
}

export { svcApi, extract, extractOnlyData, processValues, logger, fileApi, authApi };
